import { ReactElement, ReactNode, useState } from "react"
import { useParams } from "react-router-dom"
import { v4 as uuid4 } from "uuid"

import CreateEVDCDeviceProvider from "./baseProviders/createEVDCDeviceProvider"
import useStartNewEVDCDeviceVersion from "../../../../../services/middleware/hooks/devices/lct/useStartNewEvdcDeviceVersion"

interface INewEVDCDeviceVersionFormUrlParams {
    deviceRef: string
}

interface INewEVDCDeviceVersionProviderProps {
    children: ReactNode
}

const NewEVDCDeviceVersionProvider = ({
    children,
}: INewEVDCDeviceVersionProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof INewEVDCDeviceVersionFormUrlParams
    >() as INewEVDCDeviceVersionFormUrlParams

    const [attachmentUUID] = useState<string>(uuid4())

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: newEVDCDeviceVersionError,
        apiResSystemRef,
    } = useStartNewEVDCDeviceVersion(urlDeviceRef, attachmentUUID)

    return (
        <CreateEVDCDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={newEVDCDeviceVersionError}
            attachmentUUID={attachmentUUID}
            systemReference={apiResSystemRef ?? ""}
            canEditManufacturer={false}
        >
            {children}
        </CreateEVDCDeviceProvider>
    )
}

export default NewEVDCDeviceVersionProvider
